import * as SFDCActions from 'app/modules/sfdc/actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchOrgUsers } from 'app/modules/user/actions'
import { orgUsersById } from 'app/modules/user/selectors'

import SalesforceUserMapping from '../UserMapping'

function mapStateToProps(state) {
  return {
    sfdcUsers: state.get('sfdc').sfdcUsers,
    sfdcUserMappings: state.get('sfdc').sfdcUserMappings,
    users: orgUsersById(state).toJS(),
    sfdcUserMappingLoading: state.get('sfdc').sfdcUserMappingLoading
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...SFDCActions, fetchOrgUsers }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesforceUserMapping)



// WEBPACK FOOTER //
// ./src/scripts/components/SFDC/containers/UserMapping.js